import React from "react";
import { ChevronRight } from "lucide-react";
import { LINKS } from "../mock/data";
import useReveal from "../hooks/useReveal";

export default function CTASection() {
  const { ref, inView } = useReveal();
  return (
    <section id="contact" className="relative py-28 overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1640636430727-649f73271766?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxvZmZyb2FkJTIwdHJ1Y2slMjBMRUQlMjBuaWdodHxlbnwwfHx8fDE3ODY5NDE4OTF8MA&ixlib=rb-4.1.0&q=85"
        alt="Off-road at night"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#0a0a0a]/85" />
      <div
        ref={ref}
        className={`reveal ${inView ? "in-view" : ""} relative max-w-[1400px] mx-auto px-5 md:px-8 text-center`}
      >
        <h2 className="font-display text-4xl md:text-7xl uppercase leading-[0.95] text-white">
          READY TO <span className="baja-red">OWN THE DARK?</span>
        </h2>
        <p className="mt-5 text-white/70 text-lg max-w-xl mx-auto">
          Shop the full Baja Designs range in India via our official retail partner, Motousher.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <a
            href={LINKS.shop}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-baja-red hover:bg-[#ff1a44] text-white font-cond font-600 uppercase tracking-wider px-9 py-4 text-lg flex items-center gap-2 transition-colors"
          >
            Buy Now at Motousher
            <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white/40 hover:border-white text-white font-cond uppercase tracking-wider px-9 py-4 text-lg transition-colors hover:bg-white/5"
          >
            Follow Us
          </a>
        </div>
      </div>
    </section>
  );
}
